import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useFaqTitleSection = () => {
    const [data, setData] = useState({
        title: '',
        subtitle: '',
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "faqTitleSection"][0] {
                    title,
                    subtitle
                }`;

                const result = await client.fetch(query);
                setData({
                    title: result?.title || '',
                    subtitle: result?.subtitle || '',
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        title: data.title,
        subtitle: data.subtitle,
        loading: data.loading,
        error: data.error
    };
};

export const useFaqLinksSection = () => {
    const [data, setData] = useState({
        faqLinks: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "faqLinksSection"][0] {
                    faqLinks[] {
                        id,
                        name
                    }
                }`;

                const result = await client.fetch(query);
                setData({
                    faqLinks: result?.faqLinks || [],
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        faqLinks: data.faqLinks,
        loading: data.loading,
        error: data.error
    };
};

export const useFaqGroupsSection = () => {
    const [data, setData] = useState({
        faqGroups: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "faqGroupsSectionID"][0] {
                    faqGroups[] {
                        title,
                        faqs[] {
                            id,
                            title,
                            details,
                            sectionID
                        }
                    }
                }`;

                const result = await client.fetch(query);
                setData({
                    faqGroups: result?.faqGroups || [],
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        faqGroups: data.faqGroups,
        loading: data.loading,
        error: data.error
    };
}; 